import React from 'react';

import Link from '@components/link/Link.tsx';
import getFormatPrice from '@functions/getFormatPrice.ts';
import getFormatedDate from '@functions/getFormatedDate.ts';
import getUserName from '@functions/getUserName.ts';
import ReferralProcessT from '@global/models/ReferralProcess.ts';

import { RenderColsT } from '../../types.ts';

const renderReferralProcesses: RenderColsT<'referralProcesses'> = function ({
    name: colName,
    item,
}) {
    let content;
    let className;
    const referralProcess = item as ReferralProcessT;

    if (colName === 'executor') {
        className = '_innerCol';

        const LinkTag = referralProcess.exId ? Link : 'div';
        const linkProps = referralProcess.exId
            ? { pageName: 'manual-executors-inner-main' as const, ids: { 3: referralProcess.exId } }
            : undefined;

        content = (
            <div className="v2table__colInner">
                <div className="v2table__text _block">
                    <LinkTag
                        className={`v2table__text ${linkProps ? '_link _full' : ''}`}
                        {...linkProps}
                    >
                        {getUserName({ user: referralProcess.executor })}
                    </LinkTag>
                    {referralProcess.inviteExecutor && (
                        <>
                            , по приглашению{' '}
                            <Link
                                className="v2table__text _link _full"
                                pageName="manual-executors-inner-main"
                                ids={{ 3: referralProcess.inviteExId! }}
                            >
                                {getUserName({ user: referralProcess.inviteExecutor })}
                            </Link>
                        </>
                    )}
                </div>

                <div className="v2table__text _block">
                    <Link
                        className="v2table__text _link"
                        pageName="referral-main-inner"
                        ids={{ 3: referralProcess.refId }}
                    >
                        Акция «{referralProcess.referral.title}»
                    </Link>
                    <div className="v2table__text">, {referralProcess.refTypeText}</div>
                </div>
            </div>
        );
    }

    if (colName === 'count') {
        content = (
            <div className="v2table__text">
                {referralProcess.ordersCount}/{referralProcess.allOrdersCount}
            </div>
        );
    }

    if (colName === 'amount') {
        content = (
            <div className="v2table__text">{getFormatPrice(referralProcess.allAmount)} ₽</div>
        );
    }

    if (colName === 'date') {
        content = (
            <div className="v2table__text">
                С{' '}
                {getFormatedDate({
                    date: new Date(referralProcess.referral.sDate),
                    isShortYear: true,
                })}
                <br />
                по{' '}
                {getFormatedDate({
                    date: new Date(referralProcess.referral.eDate),
                    isShortYear: true,
                })}
            </div>
        );
    }

    if (colName === 'status') {
        let statusClassName = '_wait';

        if (referralProcess.status === 'invite') {
            statusClassName = '_wait';
        }

        if (referralProcess.status === 'process') {
            statusClassName = '__referral-process';
        }

        if (referralProcess.status === 'completed') {
            statusClassName = '_process';
        }

        if (referralProcess.status === 'success') {
            statusClassName = '_active';
        }

        content = (
            <div className={`v2table__status _block ${statusClassName}`}>
                {referralProcess.statusText}
            </div>
        );
    }

    return { content, className };
};

export default renderReferralProcesses;
